import React from 'react';
import cn from '@/utils/cn';
import type { SubjectContent } from '../types';

// The question as the screener saw it, inset on the recessed ground with a letter column.
const ScreenedQuestion = ({ content }: { content: SubjectContent | null }) => {
  if (!content) {
    return <p className="tw-m-0 tw-text-sm tw-text-spa-tertiary">The screened text was not retained for this row.</p>;
  }

  return (
    <div
      className={cn(
        'tw-box-border tw-rounded-lg tw-border tw-border-solid tw-border-spa-border-secondary',
        'tw-bg-spa-bg tw-px-4 tw-py-3.5',
      )}
    >
      <p className="tw-m-0 tw-text-sm tw-font-semibold tw-leading-relaxed tw-text-spa-heading">{content.stem}</p>
      {content.choices && content.choices.length > 0 && (
        <ol className="tw-m-0 tw-mt-3 tw-flex tw-list-none tw-flex-col tw-gap-1.5 tw-p-0">
          {content.choices.map((choice, index) => (
            // Choices are positional; the same text can legitimately appear twice.
            // eslint-disable-next-line react/no-array-index-key
            <li key={index} className="tw-flex tw-gap-3 tw-text-sm tw-leading-relaxed tw-text-spa-primary">
              <span className="tw-w-4 tw-shrink-0 tw-text-spa-tertiary">{String.fromCharCode(65 + index)}</span>
              <span>{choice}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default ScreenedQuestion;
